export default "__VITE_ASSET__CsIrQPwC__"